@if (!loading) {
  <div class="input-field-size-max">
    <form novalidate class="needs-validation">
      <ix-typography format="h4" id="orgFormCategoryHeader">
        {{ 'organizations.settings.header' | translate }}
      </ix-typography>
      <ix-input class="col-md-12 input-field-size-max mt-2"
        id="organizationName"
        [label]="'organizations.settings.org_name' | translate"
        [value]="orgName"
        [disabled]="true"/>
        <div class="col-md-12 input-field-size-max mt-4">
          <ix-modal-footer>
            <ix-button
              class="close-modal"
              id="orgFormEditEDCModalNoButton"
              variant="secondary"
              >
              {{ 'general.cancel' | translate }}
            </ix-button>
            <ix-button [disabled]="true" id="orgFormEditEDCModalYesButton" variant="primary">
              {{ 'general.save' | translate }}
            </ix-button>
          </ix-modal-footer>
        </div>
      </form>
    </div>
  }
  <div class="d-flex justify-content-center">
    @if (loading) {
      <ix-spinner size="large" class="mt-5"></ix-spinner>
    }
  </div>
